import { Box, Flex } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { useLandlordSettingsProvider } from "contexts/landlord-settings-provider";
import { financialOverviewModel } from "modules/landlord-portal/models/financials";
import { landlordTenancyAgreementSummaryModel } from "modules/landlord-portal/models/overview";
import { LandlordFinancialsBannerImage } from "modules/landlord-portal/screens/financial/components/banner-image/landlord-financials-banner-image";
import { FinancialOverview } from "modules/landlord-portal/screens/financial/components/financial-overview";

export function FinancialsScreen() {
  const { ownershipId } = useLandlordSettingsProvider();
  const {
    data: tenancyAgreementSummary,
    isLoading: isLoadingTenancyAgreementSummary,
  } = useQuery(landlordTenancyAgreementSummaryModel.queries.read(ownershipId));

  const { data: financialOverview, isLoading: isLoadingFinancialOverview } =
    useQuery(financialOverviewModel.queries.read(ownershipId));

  return (
    <Box>
      <Flex direction={"column"} gap={8}>
        <LandlordFinancialsBannerImage
          isLoading={
            isLoadingTenancyAgreementSummary || isLoadingFinancialOverview
          }
          propertySummary={tenancyAgreementSummary}
          financialSnapshot={financialOverview?.financial_snapshot}
        />

        <Box
          bg={"white"}
          borderRadius={"md"}
          overflow={"hidden"}
          borderWidth={1}
        >
          <FinancialOverview data={financialOverview} />
        </Box>
      </Flex>
    </Box>
  );
}
